var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealAccountsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 135,
    viewBox: "0 0 165 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10695_39082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.213 125.127H66.1426L70.9645 92.0156H111.391L116.213 125.127Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.437 97.8515H28.9203C25.7583 97.8515 23.1934 95.2865 23.1934 92.1244V13.6811C23.1934 10.5191 25.7583 7.9541 28.9203 7.9541H153.437C156.599 7.9541 159.164 10.5191 159.164 13.6811V92.1244C159.164 95.2865 156.599 97.8515 153.437 97.8515Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.136 88.4213H32.2172C29.0552 88.4213 26.4902 85.8563 26.4902 82.6943V16.3847C26.4902 13.2227 29.0552 10.6577 32.2172 10.6577H150.136C153.298 10.6577 155.863 13.2227 155.863 16.3847V82.6905C155.867 85.8563 153.302 88.4213 150.136 88.4213Z",
    fill: "#FEE7BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.827 127.538H55.5273V124.094C55.5273 121.432 57.6867 119.272 60.3492 119.272H122.005C124.668 119.272 126.827 121.432 126.827 124.094V127.538Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9823 96.2029C91.515 96.2029 92.7575 94.9603 92.7575 93.4276C92.7575 91.8949 91.515 90.6523 89.9823 90.6523C88.4495 90.6523 87.207 91.8949 87.207 93.4276C87.207 94.9603 88.4495 96.2029 89.9823 96.2029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.447 15.938H144.172C146.977 15.938 149.253 18.2138 149.253 21.0191V51.6145",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.687 25.627C141.536 23.5803 142.377 21.9992 143.211 20.8801C144.041 19.761 145.126 18.8672 146.459 18.2025C147.24 17.7932 148.052 17.504 148.9 17.3237C149.745 17.1472 150.553 16.9219 151.315 16.6515C152.077 16.3811 152.78 16.0093 153.422 15.5437C154.064 15.078 154.593 14.3419 155.01 13.3355C155.716 11.638 155.743 10.2523 155.085 9.18949C154.428 8.12295 153.459 7.32304 152.179 6.78977C150.339 6.02367 148.863 6.0124 147.744 6.74471C146.624 7.48077 145.618 8.67875 144.724 10.3387L138.013 7.54837C138.719 5.85092 139.639 4.4201 140.77 3.26343C141.9 2.10676 143.181 1.25428 144.608 0.709742C146.035 0.165205 147.575 -0.0713864 149.231 0.00747747C150.887 0.0863414 152.581 0.484416 154.315 1.20546C158.06 2.76396 160.7 4.75433 162.236 7.18034C163.768 9.60634 163.82 12.5393 162.393 15.9718C161.931 17.0834 161.417 18.0072 160.842 18.7433C160.272 19.4831 159.618 20.0952 158.886 20.5834C158.153 21.0717 157.335 21.4735 156.434 21.7889C155.528 22.1044 154.53 22.4011 153.44 22.679C152.43 22.9531 151.589 23.2423 150.913 23.5502C150.237 23.8582 149.659 24.2412 149.186 24.6919C148.712 25.1463 148.314 25.6608 147.991 26.2391C147.668 26.8175 147.349 27.4897 147.034 28.252L140.687 25.627ZM136.305 35.5826L139.136 28.7665L146.159 31.6845L143.327 38.5006L136.305 35.5826Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7646 35.8566V30.2911C99.7646 28.466 98.285 26.9863 96.4599 26.9863H64.1524C62.3273 26.9863 60.8477 28.466 60.8477 30.2911V35.8566V72.9339C60.8477 74.7591 62.3273 76.2387 64.1524 76.2387H115.815C117.64 76.2387 119.12 74.7591 119.12 72.9339V39.1614C119.12 37.3363 117.64 35.8566 115.815 35.8566H99.7646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4911 43.6304L89.9831 50.1385L83.475 43.6304L79.5469 47.5585L86.0549 54.0667L79.5469 60.5748L83.475 64.503L89.9831 57.9949L96.4911 64.503L100.419 60.5748L93.9112 54.0667L100.419 47.5585L96.4911 43.6304Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4602 127.215V122.93H11.5664V134.715L29.3857 135V132.86L19.4602 127.215Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0164 135V133.982C30.0164 132.942 29.4456 131.988 28.533 131.496L21.0185 127.44C18.7653 128.056 17.0265 127.97 15.8361 127.767C13.8607 127.433 11.9718 126.535 11.3371 127.286C11.1569 127.5 11.1343 127.782 11.1419 127.977V134.208C11.1419 134.643 11.4949 135 11.9342 135H30.0164Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.017 134.32H11.1387",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8598 130.141L24.8008 131.538",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0826 129.701L24.0273 131.098",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2758 129.295L23.2168 130.692",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0808 128.556C21.8002 129.044 19.6859 129.671 17.0196 129.656C14.4472 129.641 12.4005 129.036 11.1387 128.556",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9565 127.215V122.93H34.0664V134.715L51.8857 135V132.86L41.9565 127.215Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5164 135V133.982C52.5164 132.942 51.9456 131.988 51.033 131.496L43.5185 127.44C41.2653 128.056 39.5265 127.97 38.3361 127.767C36.3607 127.433 34.4718 126.535 33.8371 127.286C33.6569 127.5 33.6343 127.782 33.6419 127.977V134.208C33.6419 134.643 33.9949 135 34.4342 135H52.5164Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.517 134.32H33.6387",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.356 130.141L47.3008 131.538",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5825 129.701L46.5234 131.098",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7721 129.295L45.7168 130.692",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5808 128.556C44.3002 129.044 42.1859 129.671 39.5196 129.656C36.9472 129.641 34.9005 129.036 33.6387 128.556",
    stroke: "#8993A0",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4226 66.1893C37.4226 66.1893 43.9231 86.8291 44.922 89.687C45.921 92.5449 46.8486 96.5444 46.6345 100.044C46.4204 103.545 43.0631 125.112 43.0631 125.112H33.2804C33.2804 125.112 32.5894 102.328 32.2552 100.544C31.9209 98.7601 29.0668 88.658 29.0668 88.658C29.0668 88.658 28.1393 100.473 27.3544 103.612C26.5695 106.755 20.283 125.465 20.283 125.465H11.1387L14.9954 66.1855H37.4226V66.1893Z",
    fill: "#FCCACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3398 53.6051C52.3398 53.6051 55.4418 50.9726 56.2267 49.2488C56.8989 47.7767 57.8377 45.1855 58.0968 44.4682C58.1344 44.3593 58.2471 44.2992 58.3597 44.3255L58.5475 44.3705C59.1221 44.5057 59.4788 45.0841 59.3399 45.6624L59.0282 46.9543L62.3066 44.8024C62.5883 44.6184 62.9676 44.7085 63.1328 45.0015C63.2793 45.2606 63.2079 45.5873 62.9713 45.76L60.8082 47.3373L64.4021 45.6511C64.68 45.5197 65.0105 45.6249 65.1645 45.8915L65.1682 45.899C65.3297 46.1807 65.2321 46.5412 64.9466 46.7027L64.988 46.6914C65.2997 46.6013 65.6301 46.7515 65.7653 47.0482C65.923 47.3899 65.7616 47.7917 65.4161 47.9344L65.187 48.0283C65.4837 47.9344 65.7991 48.1222 65.8592 48.4264C65.9493 48.8733 65.7315 49.3239 65.3297 49.5342C64.3646 50.0375 63.7337 50.1689 62.8173 50.8562C62.0888 51.4007 62.3442 51.7462 61.5706 52.7414C60.6242 53.9506 59.8206 53.9844 58.1945 55.1824C57.5748 55.6368 56.7224 56.3466 55.8211 57.3981L52.3398 53.6051Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2802 125.108C33.2802 125.108 32.3939 101.75 32.3264 101.145C32.2588 100.54 28.9277 88.1775 28.9277 88.1775L29.5173 82.7134C29.5173 82.7134 36.2357 99.2485 36.2357 100.338C36.2357 101.427 36.983 125.112 36.983 125.112H33.2802V125.108Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4385 123.125H33.2051L33.2802 125.108H43.0629L43.4385 123.125Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8726 123.696H11.2551L11.1387 125.465H20.283L20.8726 123.696Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0371 91.7261C45.3327 95.8045 45.5393 100.221 44.6267 104.401",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9195 50.8299C54.9195 50.8299 53.2634 52.1068 51.3745 52.4373C49.1625 52.8241 47.2435 51.5172 46.7291 51.1642C45.3283 50.2065 44.8101 49.0724 43.8825 47.743C41.1373 43.8111 39.4286 41.37 37.0402 39.9843C35.8047 39.2707 33.743 38.4633 30.4871 38.7112C29.7585 38.4483 28.5943 38.6586 27.8132 38.6586C27.1635 38.6586 26.5176 38.6586 25.8679 38.6586C24.5911 38.8126 15.1801 39.9054 13.5803 38.437C12.9494 37.8587 12.9382 37.2879 12.9382 37.2879C12.9307 36.8147 13.2273 36.3265 14.0085 35.7331C15.9124 34.2835 19.4087 33.1982 20.5804 32.8527L19.8668 27.52C19.8668 27.52 19.8668 27.52 18.2971 27.52C16.7274 27.52 11.1544 28.4476 8.15758 29.4954C3.95156 30.9637 1.69833 32.0378 0.586739 34.4751C-0.806506 37.5282 0.676868 40.8105 1.06367 41.6629C2.99394 45.9329 7.27507 47.6641 9.86252 48.7081C12.142 49.6282 14.1737 50 15.5857 50.1615L14.3727 69.5883L36.7022 70.8013H40.0558C40.3111 67.8345 39.0268 58.6112 39.1958 55.5993C42.0461 59.5651 46.7704 61.5705 51.2505 60.7105C56.2114 59.7566 58.7087 55.7082 59.1143 55.0285C57.3756 51.6036 54.9195 50.8299 54.9195 50.8299Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1789 49.4216H26.9648V40.1494H28.3731V48.2311C28.3694 48.8883 27.8361 49.4216 27.1789 49.4216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.086 69.7758C39.3161 69.9185 28.7485 71.691 21.279 63.8046C14.9775 57.15 15.7211 48.7304 15.8525 47.4873C15.462 53.327 15.0676 59.1667 14.6771 65.0101H14.6546L14.3691 69.588L17.8692 69.7795L17.8654 69.7532C23.0854 70.1663 28.4743 70.4743 34.0173 70.6545C36.0489 70.7221 38.0581 70.7709 40.0484 70.801C40.0634 70.4555 40.0747 70.1137 40.086 69.7758Z",
    fill: "#C8CDD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1634 31.6431C34.5465 29.679 34.4864 28.1431 34.3737 27.1629C34.2911 26.4156 34.1597 25.8523 33.7616 25.3152C33.679 25.2026 33.018 24.3351 31.8877 24.1097C30.5357 23.8394 30.194 24.8195 28.2712 25.0599C26.6114 25.2664 26.2846 24.6055 25.1693 25.0786C23.9526 25.5969 23.3479 26.8024 23.1677 27.1667C23.0888 27.3281 22.6908 28.1431 22.6494 29.2922C22.6194 30.201 22.8259 30.8845 22.9086 31.1624C23.2541 32.3379 23.6596 34.1255 24.1591 36.9871C24.4182 36.9758 24.6773 36.9683 24.9365 36.9571C28.0159 35.1807 31.0878 33.4119 34.1634 31.6431Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5883 41.3024C26.135 41.3062 24.9558 40.1345 24.9483 38.6811L24.9258 33.0217L30.1871 33.0029L30.2096 38.6624C30.2134 40.1157 29.0417 41.2949 27.5883 41.3024Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2022 37.0772L26.7773 35.3159C26.8111 35.6126 27.0064 37.0021 28.2269 37.9597C29.008 38.5719 29.8267 38.7108 30.206 38.7521L30.2022 37.0772Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7984 31.2675C24.7834 31.1812 24.5581 31.0535 24.4868 31.0084C24.3703 30.9333 24.2427 30.8732 24.1112 30.8319C23.8558 30.7493 23.5742 30.7305 23.3076 30.7906C22.7818 30.9108 22.3199 31.3501 22.2298 31.8909C22.1772 32.2026 22.2523 32.5293 22.3875 32.8148C22.5903 33.2466 22.932 33.6109 23.3451 33.8475C23.6869 34.0465 24.0774 34.1554 24.4717 34.1817C24.5506 34.1855 25.358 34.1667 25.3542 34.1367C25.1702 33.1828 24.9862 32.2252 24.7984 31.2675Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0782 31.3241C24.142 31.7447 24.5101 33.9717 26.5192 35.5489C26.8872 35.8381 29.347 37.7646 31.5965 36.8258C34.4881 35.6165 34.1726 30.8697 34.1501 30.6143C34.0825 29.7468 33.8797 27.1856 31.7579 25.8186C30.0267 24.7033 28.1528 25.1126 27.8861 25.1765C27.6045 25.2441 25.8207 25.691 24.7279 27.441C23.7402 29.0258 23.9768 30.6331 24.0782 31.3241Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5119 30.6144C32.557 30.9862 32.8462 31.2529 33.1504 31.2153C33.4545 31.1778 33.6648 30.8435 33.6198 30.4755C33.5747 30.1037 33.2893 29.8371 32.9814 29.8746C32.6772 29.9122 32.4669 30.2426 32.5119 30.6144Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1731 31.0309C29.2181 31.4027 29.5035 31.6694 29.8115 31.6318C30.1157 31.5943 30.326 31.26 30.2809 30.892C30.2358 30.5202 29.9504 30.2536 29.6425 30.2911C29.3345 30.3287 29.1242 30.6629 29.1731 31.0309Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5025 31.1665L32.0133 31.8575C32.1072 31.9852 32.0734 32.1654 31.9382 32.2481L31.4688 32.5335",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.051 32.7772C28.1035 33.194 28.4828 33.487 28.8997 33.4344C29.3165 33.3818 29.6094 33.0025 29.5569 32.5857C29.5043 32.1688 29.125 31.8759 28.7082 31.9285C28.2951 31.9848 27.9984 32.3641 28.051 32.7772Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4449 33.1719C24.4487 33.0893 24.4562 32.5222 24.0018 32.1166C23.645 31.7974 23.232 31.7749 23.123 31.7749",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0483 32.2254C24.022 32.2217 23.7178 32.1804 23.5075 32.4095C23.3348 32.5972 23.3498 32.8301 23.3536 32.8714",
    stroke: "#262626",
    strokeWidth: 0.733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0142 30.8056C24.0142 30.8056 24.3897 30.8394 24.6713 31.1173C24.953 31.3952 25.0544 31.8759 25.0544 31.8759C25.7754 31.7896 27.424 31.4854 28.9187 30.186C29.7298 29.4837 30.2255 28.7214 30.5147 28.1731C30.7889 28.4172 31.2545 28.7852 31.9117 29.0706C32.7717 29.4424 33.842 29.6189 33.9847 29.3298C34.011 29.2772 33.9809 29.1232 33.9246 28.8115C33.9021 28.6988 33.8795 28.5336 33.827 28.3759C33.7218 28.0642 33.5829 27.7675 33.4176 27.4821C33.0871 26.915 32.6478 26.4118 32.1295 26.0062C31.7915 25.7433 31.4235 25.5255 31.0329 25.3565C29.7862 24.827 28.0549 24.827 26.5641 25.6194C26.5641 25.6194 24.9004 26.5057 24.1681 28.2444C23.9165 28.8415 23.8527 29.4387 23.8376 29.6452C23.8076 30.0546 23.8527 30.3212 23.9165 30.5277C23.9428 30.6479 23.9841 30.7418 24.0142 30.8056Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.759 31.5793C33.9017 31.5605 34.0406 31.5868 34.1646 31.6431C34.1496 32.0487 34.112 32.5444 34.0219 33.0702C33.9993 33.0739 33.9731 33.0852 33.9505 33.0852C33.5337 33.1378 33.1544 32.8411 33.1018 32.428C33.0492 32.0111 33.3421 31.6318 33.759 31.5793Z",
    fill: "#FF7769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1886 25.2705C27.9408 25.1729 27.5803 25.0414 27.1334 24.9137C26.157 24.6321 25.6688 24.4931 25.2219 24.5495C23.9188 24.7185 23.1714 26.4309 22.8598 27.152C22.6232 27.6965 22.2326 28.6203 22.4392 29.777C22.5293 30.2915 22.7133 30.6971 22.856 30.96",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1895 25.1126C28.6288 24.921 29.102 24.7633 29.5226 24.5455C29.9695 24.3127 30.3563 24.0122 30.8332 23.8357C31.3327 23.648 31.8923 23.5728 32.403 23.7306C32.8424 23.8658 33.2217 24.1587 33.5296 24.4967C33.9464 24.9548 34.2657 25.5069 34.4346 26.104C34.7539 27.2569 34.4684 28.4549 34.2807 29.6041",
    stroke: "#262626",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0693 34.1218C32.0693 34.4974 31.705 34.7978 31.2544 34.7978C30.8037 34.7978 30.4395 34.4936 30.4395 34.1218C30.4395 33.7463 30.8037 33.4458 31.2544 33.4458C31.705 33.4421 32.0693 33.7463 32.0693 34.1218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9902 28.4325L21.4924 27.5162C21.4924 27.5162 21.8003 26.1943 22.2172 25.9126C22.634 25.631 24.8534 24.771 24.8534 24.771L25.1764 25.0714C25.1764 25.0714 23.4414 26.6562 23.0809 27.3585C22.7204 28.0607 22.6528 30.0211 22.6528 30.0211L20.9554 32.2218L20.5385 32.5372L19.9902 28.4325Z",
    fill: "#F7A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11244 33.1719C3.79699 33.4235 2.17467 34.7642 1.91179 37.1376C1.62638 39.7213 3.18111 41.4939 3.42521 41.7605",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6914 56.3389C43.1083 56.8045 44.7343 58.4945 47.4607 58.8625C50.0482 59.2118 51.9785 58.149 52.5342 57.8147",
    stroke: "white",
    strokeWidth: 0.4147,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.638 65.2353L117.12 63.3726L122.287 64.319L124.871 61.5625L130.985 63.1999L134.387 58.5507L140.459 62.2723L138.394 49.1433L130.38 43.5327L111.96 46.4319C111.269 46.5408 110.799 47.1867 110.908 47.8777L113.638 65.2353Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.253 50.1085L138.397 49.1433L130.383 43.5327L131.31 49.425C131.378 49.8719 131.799 50.1798 132.253 50.1085Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.381 43.5327L131.308 49.425C131.38 49.8756 131.804 50.1836 132.255 50.1122L138.399 49.1471",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.121 82.4726C116.23 83.1636 116.876 83.633 117.567 83.5241L141.699 79.7274C142.39 79.6185 142.859 78.9725 142.75 78.2815L140.46 63.7368L134.387 60.0151L130.985 64.6644L124.871 63.027L122.287 65.7835L117.12 64.8371L113.639 66.6998L116.121 82.4726Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.642 65.2353L117.124 63.3726L122.291 64.319L124.875 61.5625L130.988 63.1999L134.391 58.5507L140.463 62.2723L138.398 49.1433L130.384 43.5327L111.964 46.4319C111.273 46.5408 110.803 47.1867 110.912 47.8777L113.642 65.2353Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.129 82.4726C116.238 83.1636 116.884 83.633 117.575 83.5241L141.707 79.7274C142.398 79.6185 142.867 78.9725 142.758 78.2815L140.467 63.7368L134.395 60.0151L130.993 64.6644L124.879 63.027L122.295 65.7835L117.128 64.8371L113.646 66.6998L116.129 82.4726Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.477 132.161C103.655 130.369 103.629 127.444 105.421 125.623L126.71 103.958L133.304 110.439L112.015 132.104C110.227 133.926 107.298 133.952 105.477 132.161Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.544 78.1654C150.045 69.8134 136.38 69.9298 128.028 78.4321C119.676 86.9306 119.792 100.597 128.294 108.949C136.793 117.301 150.459 117.184 158.81 108.682C167.162 100.18 167.046 86.5175 158.544 78.1654ZM130.961 106.23C123.961 99.3498 123.863 88.0985 130.743 81.0984C137.623 74.0983 148.874 74.0006 155.874 80.8806C162.874 87.7605 162.971 99.0118 156.092 106.012C149.215 113.012 137.961 113.11 130.961 106.23Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.205 112.434L111.373 129.566",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.965 73.5277C139.663 72.9944 134.161 74.8233 130.237 78.4323C126.312 82.0412 124.025 87.3664 124.112 92.6954",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10695_39082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealAccountsearch);
export default __webpack_public_path__ + "static/media/nonIdealAccountsearch.833c2de68f0c64a567f21c7c4e062eaa.svg";
export { ForwardRef as ReactComponent };